// extracted by mini-css-extract-plugin
export default {"logoWrp":"top-bar_layout_logoWrp__o5UM0","brand":"top-bar_layout_brand__2YzvJ","title":"top-bar_layout_title__QUCK1"};